import { Field } from 'formik';
import uniq from 'lodash-es/uniq';
import React, { useEffect, useState } from 'react';
import { ButtonClean, CurrencyInput, Fieldset, Input, RadioButton, Subsection, Textarea, useModalContext, } from '@fourthwall/components';
import { useFormikContext } from '@fourthwall/utils/dist/formik';
import { pluralize } from '@fourthwall/utils/dist/string';
import { GenerateCodesModal } from '../../../../modules/GenerateCodesModal/GenerateCodesModal';
import { generateGiftCardCode } from '../../utils/generateGiftCardCode';
import { generateGiftCardCodes } from '../../utils/generateGiftCardCodes';
import { GiftCardCodesData } from '../GiftCardCodesData/GiftCardCodesData';
import * as S from './GiftCardDetails.styled';
export const GiftCardDetails = ({ disabled, giftCards }) => {
    const { open } = useModalContext();
    const { values, touched, initialValues, errors, setFieldValue } = useFormikContext();
    const [codesInternalValue, setCodesInternalValue] = useState(initialValues.codes.join('\n'));
    useEffect(() => {
        setCodesInternalValue(initialValues.codes.join('\n'));
    }, [initialValues.codes]);
    const handleCodeGenerate = () => {
        setFieldValue('code', generateGiftCardCode());
    };
    const handleCodesGenerate = () => {
        open(GenerateCodesModal, {
            title: 'Generate gift card codes',
            prefixExample: 'GIFT',
            onSubmit: (values) => {
                if (!values.quantity) {
                    return;
                }
                const codes = generateGiftCardCodes(values.quantity, values.prefix);
                setFieldValue('codes', codes);
                setCodesInternalValue(codes.join('\n'));
            },
        });
    };
    const handleCodesChange = (e) => {
        setCodesInternalValue(e.target.value);
        setFieldValue('codes', e.target.value.split('\n').filter(Boolean));
    };
    const getCodesErrors = () => {
        if (!touched.codes) {
            return undefined;
        }
        if (typeof errors.codes === 'object') {
            return uniq(errors.codes).map((error) => React.createElement("p", null, error));
        }
        return errors.codes;
    };
    const renderGiftCardsSuggestion = () => {
        return (React.createElement(S.GiftCardsSuggestionWrapper, null,
            React.createElement("div", null,
                "Enter each code on its own line.",
                ' ',
                React.createElement(ButtonClean, { label: "Generate code for me", appearance: "secondary", onClick: handleCodesGenerate, disabled: disabled })),
            React.createElement("div", null,
                values.codes?.length,
                " gift ",
                values.codes && pluralize(values.codes.length, 'card'))));
    };
    const renderGiftCardAmount = () => {
        return (React.createElement(Fieldset.Row, null,
            React.createElement(Field, { component: CurrencyInput, name: "amount", label: "Gift card value", suggestion: "Unused balance stays available for future purchases.", fullWidth: true, disabled: disabled })));
    };
    const renderSingleGiftCard = () => {
        if (values.type !== 'SINGLE')
            return null;
        return (React.createElement(S.InnerContainer, null,
            renderGiftCardAmount(),
            React.createElement(Fieldset.Row, null,
                React.createElement(Field, { component: Input, name: "code", label: "Gift card code", suggestion: React.createElement(React.Fragment, null,
                        "Usable at checkout on any order.",
                        ' ',
                        React.createElement(ButtonClean, { label: "Generate code for me", appearance: "secondary", onClick: handleCodeGenerate, disabled: disabled })), disabled: disabled, fullWidth: true }))));
    };
    const renderMultipleGiftCard = () => {
        if (values.type !== 'MULTIPLE')
            return null;
        return (React.createElement(S.InnerContainer, null,
            renderGiftCardAmount(),
            React.createElement(Fieldset.Row, null,
                !disabled && (React.createElement(Textarea, { value: codesInternalValue, placeholder: "Gift card codes (separated by line breaks)", label: "Gift card codes (separated by line breaks)", rows: 6, suggestion: renderGiftCardsSuggestion(), error: getCodesErrors(), fullWidth: true, disabled: disabled, onChange: handleCodesChange })),
                disabled && React.createElement(GiftCardCodesData, { giftCards: giftCards }))));
    };
    return (React.createElement(Subsection, { title: "Gift card details" },
        React.createElement(Fieldset, null,
            React.createElement(Fieldset.Row, null,
                React.createElement(Field, { component: RadioButton, name: "type", checkedValue: "SINGLE", label: "Single gift card", disabled: disabled })),
            renderSingleGiftCard(),
            React.createElement(Fieldset.Row, null,
                React.createElement(Field, { component: RadioButton, name: "type", checkedValue: "MULTIPLE", label: "Multiple gift cards", disabled: disabled })),
            renderMultipleGiftCard())));
};
